import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('BuyersFilter', BuyersFilterData);

    BuyersFilterData.$inject = ['KISS_BUYER'];

    /* @ngInject */
    function BuyersFilterData(KISS_BUYER) {
        Buyer.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort,
        };

        function Buyer(buyersFilterData) {
            if (!buyersFilterData) {
                this.buildEmpty();
            } else {
                this.build(buyersFilterData);
            }
        }

        return Buyer;

        /////////////////////

        function buildEmpty() {
            this.buyerId = null;
            this.legalEntityId = null;
            this.councountryCodetry = null;
            this.statuses = _.reject(KISS_BUYER.buyer.status, s => s.value === 'DUPLICATE');
            this.email = null;
            this.lang = null;
            this.pageCriteria = {
                pageSize: KISS_BUYER.buyer.pagination.defaultPageSize,
                page: KISS_BUYER.buyer.pagination.defaultPage,
                sorts: KISS_BUYER.buyer.pagination.defaultSort,
            };
        }

        function build(buyersFilterData) {
            this.buyerId = buyersFilterData.buyerId || null;
            this.legalEntityId = buyersFilterData.legalEntityId || null;
            this.countryCode = buyersFilterData.countryCode || null;
            this.statuses = buyersFilterData.statuses || [];
            this.email = buyersFilterData.email || null;
            this.lang = buyersFilterData.lang || null;
            this.pageCriteria = {
                pageSize: buyersFilterData.pageSize || KISS_BUYER.buyer.pagination.defaultPageSize,
                page: buyersFilterData.page || KISS_BUYER.buyer.pagination.defaultPage,
                sorts: _setSort(buyersFilterData.sorts),
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return KISS_BUYER.buyer.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new Buyer(this);
            clone.pageCriteria = this.pageCriteria;
            if (this.buyer) {
                if (this.buyer.legalEntity) {
                    clone.legalEntityId = this.buyer.legalEntity.id;
                } else {
                    clone.buyerId = this.buyer.id;
                }
            }
            clone.countryCode = this.country ? this.country.code : null;
            clone.statuses = this.statuses ? _.map(this.statuses, 'value') : null;
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
